import { isDestinationService, SERVICE_STATUS, SERVICE_TYPES } from '@bagonboard/wiseman';
import PropTypes from 'prop-types';
import { path } from 'ramda';
import React from 'react';
import { Tooltip } from '@material-ui/core';

import {
  Container, IconAirplane, IconCity, IconTruck, IconWalk, Text,
} from './style';

const { CANCELLED, DECLINED } = SERVICE_STATUS;
const {
  TRANSFER, CHECKIN, CITY_DELIVERY, SKIP_BAGGAGE_CLAIM,
} = SERVICE_TYPES;

function renderIcon(type) {
  switch (type) {
    case CHECKIN:
      return <IconAirplane />;
    case CITY_DELIVERY:
      return <IconCity />;
    case TRANSFER:
      return <IconTruck />;
    case SKIP_BAGGAGE_CLAIM:
      return <IconWalk />;
    default:
      return <IconTruck />;
  }
}

const Area = ({
  original: {
    status, type, to = {},
  }, value,
}) => {
  const code = isDestinationService(type) ? to.cityCode : value;
  const isCancelled = [CANCELLED, DECLINED].includes(status);
  return (
    <Container>
      <Text cancelled={isCancelled}>{code}</Text>
      <Tooltip title={type && type.toUpperCase()} placement="top">
        {renderIcon(type)}
      </Tooltip>
    </Container>
  );
};

Area.propTypes = {
  classes : PropTypes.shape({}).isRequired,
  original: PropTypes.shape({
    areas : PropTypes.arrayOf(PropTypes.shape({ code: PropTypes.string })).isRequired,
    status: PropTypes.string,
    to    : PropTypes.shape({
      cityCode: PropTypes.string,
    }),
    type: PropTypes.string,
  }),
  value: PropTypes.string,
};

Area.defaultProps = {
  original: {},
  value   : '',
};

export default Area;
